import { useEffect, useState } from "react";
import * as S from "./style";
import { useAuth } from "context/AuthContext";
import axiosInstance from "services/axiosInstance";

// Icons
import { Circle } from "@phosphor-icons/react";

//Interface
import { IUser } from "Interfaces/IUser";

interface IProps {
  onDataChange?: (data: {
    user_id: number | null;
    user_name: string | null;
    date_sale: string;
  }) => void;
}

export default function TitleOrder({ onDataChange }: IProps) {

  const UserAuthenticated = useAuth();
  const [caixaAberto, setCaixaAberto] = useState(false);
  const [userData, setUserData] = useState<IUser[]>([]);

  // Inicializar estado com valores padrão
  const [dataInputs, setDataInputs] = useState({
    user_id: UserAuthenticated.user?.id || null,
    user_name: UserAuthenticated.user?.first_name || null,
    date_sale: new Date().toISOString().split('T')[0],
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axiosInstance.get("/user");
        setUserData(response.data.data);
      } catch (e) {
        console.log("erro", e);
      }
    };
    fetch();
  }, []);

  const handleChangeInput = (type: string, event: any) => {
    if (type === 'date_sale') {
      const newDate = event.target.value;

      // Atualiza o estado local primeiro
      setDataInputs(prev => {
        const updatedData = {
          ...prev,
          date_sale: newDate
        };

        // Depois de atualizar o estado, notifica o componente pai
        if (onDataChange) {
          onDataChange(updatedData);
        }

        return updatedData;
      });
    } else if (type === 'user_sale') {
      const selectedUserId = Number(event.target.value);
      const selectedUser = userData.find(user => user.id === selectedUserId) || UserAuthenticated.user;

      // Atualiza o estado local primeiro
      setDataInputs(prev => {
        const updatedData = {
          ...prev,
          user_id: selectedUserId,
          user_name: selectedUser?.first_name || ""
        };

        // Depois de atualizar o estado, notifica o componente pai
        if (onDataChange) {
          onDataChange(updatedData);
        }

        return updatedData;
      });
    }
  };

  useEffect(() => {
    // Função para atualizar a hora e verificar o estado do caixa
    const updateTime = () => {
      try {
        const now = new Date();

        // Convertendo a hora e minutos para um valor numérico contínuo para facilitar a comparação
        const currentHour = now.getHours();
        const currentMinutes = now.getMinutes();
        const currentTime = currentHour * 60 + currentMinutes; // Hora atual em minutos
        const openingTime = 6 * 60; // 6:00 convertido para minutos
        const closingTime = 22 * 60; // 22:00 convertido para minutos

        // Verifica se a hora atual está entre 6:00 e 22:00
        if (currentTime >= openingTime && currentTime < closingTime) {
          setCaixaAberto(true); // Define o caixa como aberto
        } else {
          setCaixaAberto(false); // Define o caixa como fechado
        }
      } catch (erro) {
        console.log("Error ao atualizar hora do caixa!");
      }
    };

    // Chama a função inicialmente para evitar atraso
    updateTime();

    // Limpa o intervalo quando o componente for desmontado
  }, []);


  return (
    <S.Container>
      <S.Title>
        {caixaAberto ? (
          <S.H4 isOpen={caixaAberto}>
            <p>Caixa Aberto</p>
            <Circle size={8} weight="fill" />
          </S.H4>
        ) : (
          <S.H4 isOpen={caixaAberto}>
            <p>Caixa Fechado</p>
            <Circle size={8} weight="fill" />
          </S.H4>
        )}
        <S.Input
          type="date"
          value={dataInputs.date_sale}
          onChange={(e) => handleChangeInput('date_sale', e)}
        />
      </S.Title>

      <S.TitleRight>
        <S.Label htmlFor="user_id">
          Vendedor
          <span>*</span>
        </S.Label>

        <S.InforUser>
          {/* <S.Select onChange={handleChange}> */}
          <S.Select onChange={(e) => handleChangeInput('user_sale', e)}>
            <option value={UserAuthenticated.user?.id} selected>
              {UserAuthenticated.user?.first_name}
            </option>
            {userData
              .filter((val) => val.id !== UserAuthenticated.user?.id)
              .map((val) => (
                <option key={val.id} value={val.id}>
                  {val.first_name}
                </option>
              ))}
          </S.Select>
        </S.InforUser>
      </S.TitleRight>
    </S.Container>
  );
}
